<template>
    <div class="pt-15 animated fadeIn equipmentList bgV2">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <gofix-card class="mb-0 heig-frame-child" fullContent>
                        <gofix-table :settings="tableConfig"
                            :table-items="tableItems"
                            @load-items="getTableData"
                            @row-click="clickToRowItem"
                            @new-item="newItem"
                            @delete-items="deleteItems"
                            @export="exportItems"
                            @import-items="importItems"
                            :tbody-tr-class="rowClass"
                            ref="gofixTable">
                            <template slot="gofix_table:actions" slot-scope="row" v-if="!row.item.is_add_manual">
                                <b-form-checkbox disabled></b-form-checkbox>
                            </template>
                            <template slot="gofix_table:created_at" slot-scope="row">
                                {{row.item.created_at | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
                            </template>
                            <template slot="gofix_table:updated_at" slot-scope="row">
                                {{row.item.updated_at | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
                            </template>
                             <template slot="gofix_table:expiry_date" slot-scope="row">
                                {{row.item.expiry_date | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY")}}
                            </template>
                        </gofix-table>
                    </gofix-card>
                </b-col>
            </b-row>
        </div>

        <b-modal 
            :no-close-on-backdrop="true" 
            id="modal-Create"
            :title="`${modals.add.data.id ? 'Edit' : 'Add'} Worker`" 
            hide-footer 
            :centered="true" 
            v-model="modals.add.open">
            <template>
                <b-row class="mb-16">
                    <b-col md="12">
                        <gofix-form-input 
                            label="IC/FIN" 
                            required
                            :disabled="modals.add.data.id ? true: false"
                            show-icon-required
                            v-model="modals.add.data.ic_fin">
                        </gofix-form-input>
                        <gofix-form-input 
                            label="Name" 
                            required
                            show-icon-required
                            v-model="modals.add.data.name">
                        </gofix-form-input>
                        <!-- <gofix-form-input 
                            label="Department" 
                            v-model="modals.add.data.department">
                        </gofix-form-input> -->
                        <gofix-form-dropdown 
                            label="Company" 
                            vLabel="name"
                            required
                            show-icon-required
                            appendToBody
                            :filterable="false"
                            @search="searchCompanies"
                            v-model="modals.add.data.company" 
                            :options="modals.add.options.companies">
                        </gofix-form-dropdown>
                        <!-- <gofix-form-input 
                            label="Work Permit Number" 
                            required
                            show-icon-required
                            v-model="modals.add.data.work_permit_number">
                        </gofix-form-input> -->
                        <gofix-form-input-date
                            show-icon-required
                            required
                            :minDate="new Date()" 
                            v-model="modals.add.data.expiry_date"
                            label="Work Permit Expiry">
                        </gofix-form-input-date>
                    </b-col>
                </b-row> 
            </template>
            <b-button-group class="d-block text-right pr-4">
                <gofix-button label="APPLY" @click="save" :disabled="modals.add.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </div>
</template>

<script>
import { filters } from '@/_filterVar.js'
import moment from 'moment';
export default {
    name: 'safety-workers-list',
    data() {
        let filter = JSON.parse(JSON.stringify(filters['safety_app_workers_listing']));
        return {
            tableConfig:{
                name: 'safety-app-workers-listing',
                controls:{
                    create: this.$checkRole(this.$accessModule.safety_app_workers, 'create'),
                    delete: this.$checkRole(this.$accessModule.safety_app_workers, 'delete'),
                    tableExport: false,
                    tableColumnSettings: false
                },
                filter: filter,
                page: 1,
                limit: 100,
                total: 0,
                sortColumn: "created_at",
                sortDirection: "desc",
                fields: [
                        {
                            key: 'actions',
                            label: '',
                            thClass: 'checkbox-column text-center',
                            tdClass: 'checkbox-column text-center',
                            width: 50,
                            thStyle: "width:50px",
                        },
                        {
                            key: 'ic_fin',
                            label: 'IC/FIN',
                            thStyle: "width:200px",
                            width: 200,
                            isActive: 1,
                            isFilter: true,
                            sorting: true
                        },
                        {
                            key: 'name',
                            label: 'Name',
                            thStyle: "width:300px",
                            width: null,
                            isActive: 1,
                            isFilter: true,
                            sorting: true
                        },
                        {
                            key: 'department',
                            label: 'Department',
                            isActive: 1,
                            isFilter: true,
                            thStyle: "width:300px",
                            width: 150,
                            sorting: true
                        },
                        {
                            key: 'company',
                            label: 'Company',
                            isActive: 1,
                            isFilter: true,
                            thStyle: "width:300px",
                            width: 150,
                            sorting: true
                        },
                        // {
                        //     key: 'work_permit_number',
                        //     label: 'Work Permit Number',
                        //     isActive: 1,
                        //     isFilter: true,
                        //     thStyle: "width:300px",
                        //     width: 150,
                        //     sorting: true
                        // },
                        {
                            key: 'expiry_date',
                            label: 'Work Permit Expiry',
                            isActive: 1,
                            isFilter: true,
                            thStyle: "width:300px",
                            width: 150,
                            sorting: true
                        },
                        {
                            key: 'created_at',
                            label: 'Created At',
                            isActive: 1,
                            isFilter: true,
                            thStyle: "width:300px",
                            width: 150,
                            sorting: true
                        },
                        {
                            key: 'updated_at',
                            label: 'Updated At',
                            isActive: 1,
                            isFilter: true,
                            thStyle: "width:300px",
                            width: 150,
                            sorting: true
                        }
                    ]
            },
            tableItems: [],
            modals: {
                add: {
                    open: false,
                    loading: false,
                    data: {
                        id: null,
                        name: null,
                        ic_fin: null,
                        department: null,
                        company: null,
                        expiry_date: null,
                        work_permit_number: null,
                    },
                    options: {
                        companies: []
                    }
                }
            },
            timer: {
                save: null
            },
        }
    },
    computed: {
        // Add computed properties here
    },
    watch: {
    },
    methods: {
        async getTableData(callback) {
            // Handle loading table data
            try {
                const { tableRequest , resolve,reject } = await callback();
                await this.$store.dispatch("SafetyAppController/getworkerItems", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load list of workers", "danger");
                        reject();
                    })
            } catch (error) {
                console.error('Error fetching table data:', error)
            }
        },  
        clickToRowItem(item) {
            if(!this.$checkRole(this.$accessModule.safety_app_workers, 'update')) return
            this.modals.add.data = {
                id: item.id,
                name: item.name,
                ic_fin: item.ic_fin,
                department: item.department,
                company: null,
                expiry_date: item.expiry_date ? new Date(item.expiry_date) : null,
                work_permit_number: item.work_permit_number ? item.work_permit_number : null,
            };

            if(item.company_id && item.company) {
                this.modals.add.data.company = {
                    id: item.company_id,
                    name: item.company
                };
            }

            this.modals.add.open = true;
        },
        newItem() {
            if(!this.$checkRole(this.$accessModule.safety_app_workers, 'create')) return
            this.modals.add.data = {
                id: null,
                name: null,
                ic_fin: null,
                department: null,
                company: null,
                expiry_date: null,
                work_permit_number: null,
            };
            this.modals.add.open = true;
        },
        async deleteItems(callback){
            const { ids,filter, resolve,reject } = await callback();
            this.$store.dispatch("SafetyAppController/deleteWorkerItems", ids)
            .then(response => {
                resolve(this.$notificationV2('deleting', 'safety_worker'));
            })
            .catch(err =>{
                reject(err);
            });
        },
        exportItems() {
            // Handle exporting items
            // Implement export logic (e.g., to CSV, PDF, etc.)
        },
        async importItems(callback){
            const { file, resolve, reject } = await callback();

            await this.$store.dispatch(`SafetyAppController/importWorkerItems`, {
                fileImport: file
            })
                .then(response => {
                    let variant = 'success';
                    let msg = 'Workers imported successfully.';
                    let result = response.data.data;
                    if(result.data && result.data.count && result.data.count.failed ) {
                        variant = 'danger';
                        msg = "Some rows cannot be imported. Please go to Import Logs for more details.";
                    }

                    this.$alertNotification(msg, variant);
                    resolve();
                })
                .catch(error => {
                    reject(error);
                });
            },
        save() {
            if (this.timer.save) {
                clearTimeout(this.timer.save);
                this.timer.save = null;
            }
            this.timer.save = setTimeout(async () => {
                
                if(!this.modals.add.data.id && !this.modals.add.data.ic_fin) {
                    return this.$alertNotification("IC/FIN is required.", "danger");
                }

                if(!this.modals.add.data.name) {
                    return this.$alertNotification("Name is required.", "danger");
                }

                if(!this.modals.add.data.company) {
                    return this.$alertNotification("Please choose a company.", "danger");
                }

                if(!this.modals.add.data.expiry_date) {
                    return this.$alertNotification("Work Permit Expiry Date is required.", "danger");
                }

                if(this.modals.add.loading) return;
                this.modals.add.loading = true;

                let objeClone = {
                    id: this.modals.add.data.id,
                    data: {
                        name: this.modals.add.data.name,
                        company_id: this.modals.add.data.company.id,
                        company: this.modals.add.data.company.name,
                        department: this.modals.add.data.department,
                        expiry_date: this.modals.add.data.expiry_date ? moment(this.modals.add.data.expiry_date).format('YYYY-MM-DD') : null,
                        work_permit_number: this.modals.add.data.work_permit_number,
                    }
                };

                if(!this.modals.add.data.id) {
                    objeClone.data.ic_fin = this.modals.add.data.ic_fin;
                }
                
                this.$store.dispatch("SafetyAppController/saveWorkerItem", objeClone)
                .then(async response => {
                    this.modals.add.loading = false;
                    if(response.code && response.message) {
                        this.$alertNotification(response.message, "danger");
                        return;
                    }
                    this.modals.add.open = false;
                    this.$refs.gofixTable.reloadTableItems();
                    this.$alertNotification(this.$notificationV2('adding', 'safety_worker'), "success");
                })
                .catch(err => {
                    this.modals.add.loading = false;
                    if( err.response.data.error && err.response.data.error.message ) {
                        this.$alertNotification(err.response.data.error.message, "danger"); 
                    }
                })

            }, 200);
        },
        async getCompanies(search = '') {
            let tableRequest = {
                page: 1, 
                isCMS: 1,
                filter: { 
                    name: { type: "text", value: search, function: "ilike", with: [] },
                    is_supplier: { type: 'boolean', value: true },
                    is_safety: { type: 'boolean', value: true },
                }, 
                limit: 100
            }

            await this.$store.dispatch("OrganizationController/getItemsNoCommit", tableRequest)
                .then(response => {
                    this.modals.add.options.companies = response.data.data.items;
                })
                .catch(err => {})
        },
        async searchCompanies(search, loading) {
            loading(true)
            this.modals.add.options.companies = []
            if (this.timer.companies) {
                clearTimeout(this.timer.companies);
                this.timer.companies = null;
            }
            this.timer.companies = setTimeout(async () => {
                try {
                    await this.getCompanies(search);
                    await loading(false)
                } catch(e) {
                    loading(false)
                }
            }, 500);
        },
        rowClass(item) {
            if (item && item.expiry_date) {
                let today = moment().format("YYYY-MM-DD");
                if (moment(today).isAfter(moment(item.expiry_date).format("YYYY-MM-DD"))) {
                    return 'bg-danger';
                }
            }
            return null;
        },
    },
    created() {
        this.getCompanies();
    }
}
</script>